import React, { useState, useEffect } from "react";
import { message, Form, Row, Col, Input, Select, Button, Typography, Divider, Space, Modal } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import http from "../../../../../services/http";
const { TextArea } = Input;
const { Text } = Typography;

const options_status = [
	{ value: -1, label: "Em formação", disabled: true },
	{ value: 0, label: "Ag. Avaliação" },
	{ value: 1, label: "Ideia Aceita (Aguardando Mais Informações)" },
	{ value: 2, label: "Ideia com oportunidade" },
	{ value: 3, label: "Retorno de Informações", disabled: true },
	{ value: 4, label: "Em desenvolvimento" },
	{ value: 5, label: "Finalizado" },
];
export const SugestoesAvaliar = ({ idSugestao, onFinish }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [modal, contextHolder] = Modal.useModal();
	const [areas, setAreas] = useState([]);
	const [classificacoes, setClassificacoes] = useState([]);

	useEffect(() => {
		if (idSugestao > 0) {
			listarAreas();
			listarClassificacao();
			carregarSugestao(idSugestao);
		}
	}, [idSugestao]);

	// CARREGAR SUGESTÃO
	const carregarSugestao = async (id) => {
		if (!id) return;
		setLoading(true);
		const api = await http("get", `v1/sugestoes/carregar/${id}`, []);
		if (api.statusCode === 200) {
			form.setFieldsValue({
				id_sugestoes_cad_areas: api?.response?.data?.id_sugestoes_cad_areas,
				id_sugestoes_cad_classificacao: api?.response?.data?.id_sugestoes_cad_classificacao,
				status: api?.response?.data?.status,
				emails: [api?.response?.data?.email_responsavel],
			});
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// LISTAR ÁREAS
	const listarAreas = async () => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_areas/listar_ativas`, []);
		if (api.statusCode === 200) {
			let array_areas = [];
			if (api.response.data) {
				api.response.data.map((col) => {
					array_areas.push({ value: col.id, label: col.descricao });
				});
			}
			setAreas(array_areas);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// LISTAR CLASSIFICAÇÃO
	const listarClassificacao = async () => {
		setLoading(true);
		const api = await http("get", `v1/sugestoes_classificacao/listar_ativas`, []);
		if (api.statusCode === 200) {
			let array_classificacoes = [];
			if (api.response.data) {
				api.response.data.map((col) => {
					array_classificacoes.push({ value: col.id, label: col.descricao });
				});
			}
			setClassificacoes(array_classificacoes);
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// ENVIAR AVALIAÇÃO
	const enviarAvaliacao = async (formulario) => {
		if (!formulario.id_sugestoes) return;
		setLoading(true);
		const api = await http("post", `v1/sugestoes/enviar_avaliacao`, formulario);
		if (api.statusCode === 200) {
			message.success("Avaliação enviada com sucesso!");
			onFinish();
		} else {
			message.error(api.response.message);
		}
		setLoading(false);
	};

	// SUBMIT CADÁSTRO
	const onSubmit = (formulario) => {
		if (formulario.status === -1 || formulario.status === 3) {
			message.error("Informe um status válido!");
			return;
		}

		formulario.emails = formulario.emails.filter((value, index, self) => self.indexOf(value) === index);

		formulario.id_sugestoes = idSugestao;
		enviarAvaliacao(formulario);
	};

	return (
		<Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
			<Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
				<Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24}>
					<Form.Item name="descricao" label="Descrição" rules={[{ required: true, message: "Digite a descrição!" }]}>
						<TextArea
							size="large"
							autoSize={{ minRows: 3, maxRows: 5 }}
							placeholder="Informe a descrição"
							disabled={loading}
						/>
					</Form.Item>
				</Col>

				<Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
					<Form.Item
						name="id_sugestoes_cad_areas"
						label="Área da ideia"
						rules={[{ required: true, message: "Selecione a área!" }]}>
						<Select
							size="large"
							placeholder="Selecione a área"
							disabled={loading}
							style={{ width: "100%" }}
							options={areas}
						/>
					</Form.Item>
				</Col>

				<Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
					<Form.Item
						name="id_sugestoes_cad_classificacao"
						label="Classificação"
						rules={[{ required: true, message: "Selecione a classificação!" }]}>
						<Select
							size="large"
							placeholder="Selecione a classificação"
							disabled={loading}
							style={{ width: "100%" }}
							options={classificacoes}
						/>
					</Form.Item>
				</Col>

				<Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
					<Form.Item
						name="status"
						label="Status"
						rules={[
							{ required: true, message: "Selecione o status!" },
							{
								message: "Status inválido!",
								validator: (__, val) => {
									if (val === -1 || val === 3) {
										return Promise.reject("Status inválido!");
									}
									return Promise.resolve();
								},
							},
						]}>
						<Select
							size="large"
							placeholder="Selecione o status"
							disabled={loading}
							style={{ width: "100%" }}
							options={options_status}
						/>
					</Form.Item>
				</Col>

				<Divider />

				<Col className="gutter-row" span={24}>
					<Space direction="vertical" style={{ width: "100%" }}>
						<Text>E-mails</Text>
						<Form.List name="emails">
							{(fields, { add, remove }) => (
								<>
									{fields.map((field) => (
										<Form.Item required={false} key={field.key}>
											<Input.Group compact>
												<Form.Item
													{...field}
													noStyle
													rules={[
														{
															type: "email",
															message: "Informe um e-mail válido!",
														},
													]}>
													<Input
														placeholder="Informe um e-mail!"
														disabled={loading}
														style={{ width: "calc(100% - 40px)" }}
													/>
												</Form.Item>
												{fields.length > 0 ? (
													<Button
														icon={<MinusCircleOutlined />}
														onClick={() => {
															remove(field.name);
														}}
													/>
												) : null}
											</Input.Group>
										</Form.Item>
									))}
									<Form.Item>
										<Button type="dashed" onClick={() => add()} icon={<PlusOutlined />}>
											Adicioanar campo
										</Button>
									</Form.Item>
								</>
							)}
						</Form.List>
					</Space>
				</Col>

				<Col className="gutter-row" span={24}>
					<Button
						type="primary"
						size="large"
						onClick={() => {
							modal.confirm({
								title: "Deseja realizar esta alteração?",
								okText: "Sim",
								cancelText: "Cancelar",
								onOk() {
									form.submit();
								},
							});
						}}>
						Salvar
					</Button>
				</Col>
			</Row>
			{contextHolder}
		</Form>
	);
};
